import { useQuery } from '@tanstack/react-query'
import {
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
  type PermissionCode
} from '@super-mega/server/contracts/authorization'
import { AUTH_SESSION_STALE_TIME } from '@/const/auth.ts'
import { useTRPC } from '@/trpc/react.ts'
import { canVisitRoute } from '@/utils/route-access.ts'

export function useAccess() {
  const trpc = useTRPC()
  // 直接订阅已有 Session Query，授权状态仍由同一份 TanStack Query 缓存管理。
  const query = useQuery({
    ...trpc.auth.session.queryOptions(),
    staleTime: AUTH_SESSION_STALE_TIME,
    refetchOnMount: false
  })
  const session = query.data ?? null
  return {
    session,
    can: (code: PermissionCode) => !!session && hasPermission(session, code),
    all: (codes: readonly PermissionCode[]) => !!session && hasAllPermissions(session, codes),
    any: (codes: readonly PermissionCode[]) => !!session && hasAnyPermission(session, codes),
    visit: (pathname: string) => !!session && canVisitRoute(session, pathname)
  }
}
